<template>
  <div id="box">
    <el-container>
      <el-header>
        <div class="top">
          <div class="top_mian">
            <span>香味研究所</span>
            <div class="userInfo" v-if="userInfo">
              {{ userInfo.account }} <span @click="signOut">退出</span>
            </div>
          </div>
        </div>
      </el-header>
      <el-main>
        <div class="content">
          <slot></slot>
        </div>
      </el-main>
      <!-- <el-footer> <div class="bottom">寄信小程序 | 沪ICP备7777777号</div></el-footer> -->
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: "",
    };
  },
  created() { },
  mounted() {
    var userInfo = sessionStorage.getItem("USER");
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
    }
  },
  watch: {
    $route(to, from) {
      var userInfo = sessionStorage.getItem("USER");
      if (userInfo) {
        this.userInfo = JSON.parse(userInfo);
      }
    },
  },
  methods: {
    // 退出
    signOut: function (res) {
      window.sessionStorage.clear(); //清除缓存
      sessionStorage.removeItem('USER')
      sessionStorage.removeItem('TOKEN')
      this.$store.commit("setToken", "");
      this.userInfo = "";
      this.$router.push("/Login");
    },
  },
};
</script>

<style scoped lang="less">
.el-header,
.el-footer {
  padding: 0;
}

.el-main {
  padding: 0;
  height: calc(100vh - 60px);
  overflow: hidden;
}

#box {
  width: 100%;
  height: 100vh;
  background: #fff;
  position: relative;

  .top {
    width: 100%;
    height: 60px;
    background: #000;
    color: #fff;
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;

    .top_mian {
      width: 100%;
      margin: auto;
      font-family: "黑体";
      line-height: 40px;
      font-size: 17px;
      padding: 5px 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      span {
        font-weight: bold;
      }
    }
  }

  // 主体部分
  .content {
    height: 100%;
    overflow: hidden;
  }

  .bottom {
    width: 100%;
    height: 85px;
    line-height: 80px;
    background: #000;
    text-align: center;
    font-size: 15px;
    bottom: 0px;
    z-index: 1000;
    color: #fff;
    position: relative;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/manageBox.vue